import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

import { logoutUrl, supportUrl } from "@constants";
import { applicationSpaRoutes } from "@shared/constants/routes";

import type { INavigationSection } from "./Drawer.types";

export const navigationLinkTypes = {
  spaRoute: "spaRoute",
  external: "external",
  newTab: "newTab",
} as const;

export const navigationSections: INavigationSection[] = [
  {
    titleKey: "drawerV2.menuTitle",
    items: [
      {
        itemKey: "myOverview",
        icon: HomeOutlinedIcon,
        href: applicationSpaRoutes.myOverview,
        linkType: navigationLinkTypes.spaRoute,
      },
      {
        itemKey: "myDocuments",
        icon: DescriptionOutlinedIcon,
        href: applicationSpaRoutes.myDocuments,
        linkType: navigationLinkTypes.spaRoute,
      },
      {
        itemKey: "identityDocuments",
        icon: UploadFileOutlinedIcon,
        href: applicationSpaRoutes.identityDocuments,
        linkType: navigationLinkTypes.spaRoute,
      },
      {
        itemKey: "createDocument",
        icon: NoteAddOutlinedIcon,
        href: applicationSpaRoutes.createDocument,
        linkType: navigationLinkTypes.spaRoute,
      },
      { itemKey: "support", icon: HelpOutlineIcon, href: supportUrl, linkType: navigationLinkTypes.newTab },
    ],
  },
  {
    titleKey: "drawerV2.accountTitle",
    items: [
      {
        itemKey: "myProfile",
        icon: PersonOutlineIcon,
        href: applicationSpaRoutes.profileEdit,
        linkType: navigationLinkTypes.spaRoute,
      },
      {
        itemKey: "logout",
        icon: LogoutOutlinedIcon,
        href: logoutUrl,
        linkType: navigationLinkTypes.external,
      },
    ],
  },
];
